export const HOTJAR_EVENTS = {
  TAG_RECORDING: "tagRecording"
}  